import styled from 'styled-components';
import { DefaultTheme } from '../themes/DefaultTheme';

function MenuItemMixin() {
  return `
    padding: 0;
    margin: 0;
    display: block;
    border: none;
    height: auto;
    text-align: left;
    border-top: none;
    line-height: 1em;
    font-size: 16px;
    text-transform: none;
    box-shadow: none;
    padding: 0.8rem 1.1rem;
    box-sizing: border-box;
    white-space: normal;
    word-wrap: normal;
    background-color: white;
    text-decoration: none;
  `;
}

export const MultiSelectElement = styled.div`` as any;

export const FaceElement = styled.div`
  ${props => props.theme.partials.form.item.default};
  justify-content: space-between;
` as any;

export const InputElement = styled.input`
  color: ${props => props.theme.vars.newColor.darkGS1};
  background: transparent;
  margin: 0;
  border: none;
  outline: none;
  display: flex;
  flex: 1;
  ::placeholder {
    color: ${props => props.theme.vars.newColor.darkGS3};
  }
  &.inactive {
    color: transparent;
    text-shadow: 0 0 0 ${props => props.theme.vars.newColor.darkGS1};
  }
` as any;

export const MenuListElement = styled.ul`
  margin: 0;
  padding: 0;
  margin-top: 5px;
  border: ${({ numItems }: any) => (numItems > 0 ? '1px solid rgba(0, 0, 0, 0.1)' : 'none')};
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.3);
  max-height: ${({ menuHeight }: any) => menuHeight}px;
  border-radius: 5px;
  overflow: auto;
  position: absolute;
  left: 2px;
  right: 2px;
  z-index: 11;
  background-color: white;
  text-decoration: none;
  margin-bottom: 30px;
` as any;

export const MenuItemElement = styled.li`
  ${MenuItemMixin()};
  cursor: pointer;
  text-align: left;
  color: #1a1d1f;
  background-color: ${(props: any) => (props.isHighlighted ? DefaultTheme.dropdown.menuItem.hoverBgColor : 'white')};

  &:focus {
    outline: 0;
  }
` as any;

export const NoItemsElement = styled.li`
  ${MenuItemMixin()};
  color: #93abbc;
  text-align: center;
` as any;

export const TagListElement = styled.div`
  display: flex;
  flex-flow: row wrap;
  padding-top: 10px;
  padding-bottom: 5px;
  flex: 1;
  input {
    margin-bottom: 5px;
    min-height: 30px;
    padding: 0;
  }
` as any;

export const TagWrapperElement = styled.div`
  margin: 0 10px 5px 0;
  &.active {
    > div {
      box-shadow: 0 0 5px 2px ${props => props.theme.vars.newColor.blue2};
    }
  }
` as any;

export const MenuButtonElement = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
  padding: 0;
  color: #647079;
  background: none;
  border: none;
  width: 20px;
  height: 20px;
  border-radius: 5px;
  :hover,
  :focus {
    background: ${props => props.theme.vars.newColor.lightGS1};
    outline: none;
  }
` as any;
